import React from "react";
import { observer, inject } from "mobx-react";
import * as M from "@material-ui/core";
import { values } from "mobx";
import { clone } from "mobx-state-tree";
import * as H from "../../helpers";

const GroupSelector = ({ hideCounter, store, responses }) => {
  const { $group, $router, $survey, $respondent, $user, $alert } = store;

  return (
    <M.TextField
      select
      disabled={
        (!$user.sessionUser.isVerifiedCreator && $user.sessionUser.groupsArr.length === 1) ||
        $alert.list.size > 0
      }
      onChange={e => {
        if (e.target.value) {
          $group.setSelected(clone($group.list.get(e.target.value)));
        } else {
          $group.destroy($group.selected);
        }
        if ($survey.selected) {
          if ($router.mode === "results") {
            let groupKeys = $group.activeGroupKeys;
            if (groupKeys.length) {
              $respondent.load($survey.selected._key, groupKeys);
            } else {
              $respondent.load($survey.selected._key, e.target.value);
            }
          }
        }
      }}
      name={"group"}
      value={$group.selected ? $group.selected._key : 0}
    >
      <M.MenuItem value={0}>
        {`Alle groepen/scholen ${
          $router.mode === "results" ? "(" + $survey.selected.respondentCount + " inzendingen)" : ""
        }`}
      </M.MenuItem>
      {!$user.sessionUser.isVerifiedCreator &&
      $user.sessionUser.groupsArr.length === 1 &&
      $group.selected ? (
        <M.MenuItem value={$group.selected._key}>
          {`${$group.selected.name} (${$group.selected.respondentCountForSelectedSurvey} inzendingen)`}
        </M.MenuItem>
      ) : (
        values($group.list)
          .sort(H.compare("name", "asc"))
          .map((group, i) => (
            <M.MenuItem key={i} value={group._key}>
              {`${group.name} ${
                !hideCounter ? `(${group.respondentCountForSelectedSurvey} inzendingen)` : ""
              }`}
            </M.MenuItem>
          ))
      )}
    </M.TextField>
  );
};

export default inject("store")(observer(GroupSelector));
